<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">运营</a></el-breadcrumb-item>
          <el-breadcrumb-item>公众号对接</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="form" label-width="160px">
        <el-form-item label="appid">
          <el-col :span="11">
            <el-input v-model="form.weChat_OfficialAccount_appid" >
              <el-button slot="append" v-if="form.wechatOpenUse">重新授权</el-button>
            </el-input>
          </el-col>
        </el-form-item> 
        <el-form-item label="APPSECRET" v-if="!form.wechatOpenUse">
          <el-col :span="11">
            <el-input v-model="form.weChat_OfficialAccount_APPSECRET"></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="TOKEN" v-if="!form.wechatOpenUse">
          <el-col :span="11">
            <el-input v-model="form.weChat_OfficialAccount_TOKEN">              
              <el-button slot="append" @click="CreateToken" >生成</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="多客服">
          <el-col :span="11">
            <el-switch
              v-model="form.weChat_OfficialAccount_CustomerService">
            </el-switch>
          </el-col>
        </el-form-item> -->
        <el-form-item label="关注二维码">
          <el-col :span="11">
            <el-upload
              class="icon-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleIconSuccess"
              :before-upload="beforeIconUpload">
              <img v-if="form.weChat_OfficialAccount_QrCode" :src="form.weChat_OfficialAccount_QrCode" class="icon">
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item label="业务域名/js安全域名">
          <el-col :span="11">
            <div slot="tip" class="el-upload__tip">{{form.mobieDomain}}</div>
          </el-col>
        </el-form-item>        
        <el-form-item label="校验文件">
          <el-col :span="11">
            <el-upload
              class="upload-demo"
              :action="uploadWechatFileUrl"
              :headers="headers">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
        </el-form-item>  
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveWechatSet">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import qs from 'qs' 
  export default {
    props:{
    },
    data (){
      return {
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        uploadWechatFileUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        form:{}
      }
    },
    computed:{      
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/Wechat/WechatSetGet',         
        params:{}
      }).then(function (resp) {
        that.form = resp.data       
      })
    },
    methods:{     
      SaveWechatSet:function(){
        var that = this
        var dataObj = qs.stringify(that.form)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveParameter', 
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },        
          data:dataObj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleIconSuccess(res, file){
        this.chainStore.Icon= res.fullUrl
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeIconUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;        
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      CreateToken:function(){
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        var Str = "";
        for (var i = 0; i < 16; i++){
          var Rand = Math.floor(Math.random() * 36)
          Str += chars[Rand];
        }
        this.form.weChat_OfficialAccount_TOKEN = Str
      }
    },
    components:{    
      
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px 
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
</style>